<template>
  <template v-if="!isAdmin">
    <transition name="site-loader-fade">
      <SiteLoader v-if="siteLoaderVisible" />
    </transition>
    <NavBar />
    <router-view v-slot="{ Component }">
      <div class="page-content">
        <component :is="Component" :key="$route.fullPath" />
      </div>
    </router-view>
    <FooterComp />
  </template>
  <template v-else>
    <router-view />
  </template>
</template>

<script>
import NavBar from '@/layout/NavBar.vue'
import FooterComp from '@/layout/FooterComp.vue'
import SiteLoader from '@/components/SiteLoader.vue'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: { NavBar, FooterComp, SiteLoader },
  computed: {
    ...mapState(['siteLoaderVisible']),
    isAdmin() {
      return this.$route.meta?.isAdmin === true
    },
  },
}
</script>
